
export const setPosition = (targetPath) => {
  sessionStorage.setItem(targetPath, window.scrollY);
}

export const resetPosition = (targetPath) => {
  sessionStorage.setItem(targetPath, 0);
}

export const getPosition = (targetPath) => {
  const savedPosition = sessionStorage.getItem(targetPath);
  if (savedPosition) {
    window.scrollTo({
      left: 0,
      top: parseInt(savedPosition, 10),
      behavior: 'instant'
    });
  }
}
